import { CustomAlertCard } from '@/shared/components/ui/Alerts';
import { OrdenTrabajo } from '@/shared/interfaces';
import { IOrdenServicioCorporativo } from '@/shared/interfaces/erp/orden_servicio_corporativo';

export type EquipoAdicionalInstallTectAsigProps = {
  ordenTrabajo: OrdenTrabajo | IOrdenServicioCorporativo;
  isOnlyView?: boolean;
};

const EquipoAdicionalInstallTectAsig: React.FC<
  EquipoAdicionalInstallTectAsigProps
> = ({ 
  ordenTrabajo,
  isOnlyView = false 
}) => {
  const isRouterAc = ordenTrabajo?.es_router_ac;
  const isWifi6 = ordenTrabajo?.requiere_wifi_6;

  const messageAc = isRouterAc
    ? `Se ${
        isOnlyView ? 'seleccionó' : 'requiere'
      } Router AC como equipo adicional`
    : '';
  const messageWifi6 = isWifi6
    ? `Se ${
        isOnlyView ? 'seleccionó' : 'requiere'
      } Router Wifi 6 como equipo adicional`
    : '';

  const alertMessage = `${messageAc}  ${
    messageWifi6 ? 'y' : ''
  } ${messageWifi6}`;

  if (!isRouterAc && !isWifi6) return null;

  return (
    <>
      <CustomAlertCard
        alertTitle="Equipos Adicionales"
        alertMessage={alertMessage}
      />
    </>
  );
};

export default EquipoAdicionalInstallTectAsig;
